/**
 * Admin panel route tree (ADMIN_FLOW.md §8.1). Mounted at /admin/* from
 * App.tsx, OUTSIDE the tenant layouts: no tenant sidebar, no tenant auth,
 * no tenant redirects. The tenant authStore is never consulted here.
 */
import { useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { useAdminAuthStore } from './adminAuthStore'
import { RequireAdmin } from './components/RequireAdmin'
import { AdminShell } from './components/AdminShell'
import AdminLoginPage from './pages/AdminLoginPage'
import BugsListPage from './pages/BugsListPage'
import BugDetailPage from './pages/BugDetailPage'
import SuggestionsPage from './pages/SuggestionsPage'
import RatingsPage from './pages/RatingsPage'
import StatusPage from './pages/StatusPage'

export default function AdminApp() {
  const bootstrap = useAdminAuthStore((s) => s.bootstrap)
  useEffect(() => {
    void bootstrap()
  }, [bootstrap])

  return (
    <Routes>
      <Route path="login" element={<AdminLoginPage />} />
      <Route element={<RequireAdmin />}>
        <Route element={<AdminShell />}>
          <Route index element={<Navigate to="status" replace />} />
          <Route path="status" element={<StatusPage />} />
          <Route path="bugs" element={<BugsListPage />} />
          <Route path="bugs/:id" element={<BugDetailPage />} />
          <Route path="suggestions" element={<SuggestionsPage />} />
          <Route path="ratings" element={<RatingsPage />} />
          <Route path="*" element={<Navigate to="status" replace />} />
        </Route>
      </Route>
    </Routes>
  )
}
